export const FIELD_ALLOCATION_KEY = 'fieldAllocation';

export const MOCK_RUN_HISTORY_FETCH_TYPE = {
  CURRENT_MONTH: 'CURRENT_MONTH',
  LAST_MONTH: 'LAST_MONTH'
};

export enum MockStatus {
  INITIATED = 'INITIATED',
  PREPARING_INPUTS = 'PREPARING_INPUTS',
  INPUTS_READY = 'INPUTS_READY',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  APPROVED = 'APPROVED',
  ALLOCATED = 'ALLOCATED'
}

export enum InputValidationType {
  AGENCY_CAPPING = 'agencyCapping',
  PINCODE_SERVICEABILITY = 'pincodeServiceAbility',
  ADDRESS_PRIORITISATION = 'addressPrioritization'
}

export enum InputStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export enum MockAllocationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING'
}

export enum MockTriggerType {
  TRIGGER = 'TRIGGER',
  APPROVE = 'APPROVE'
}

export enum RightHeaderType {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT'
}

export enum ValidationType {
  INHOUSE = 'inhouse',
  EXTERNAL = 'external'
}

export enum ModalStep {
  VALIDATE = 'VALIDATE',
  CONFIRM = 'CONFIRM'
}

export const AGENCY_CAPPING_OPTIONS = [
  {
    id: 'included',
    value: 'true',
    label: 'Include'
  },
  {
    id: 'excluded',
    value: 'false',
    label: 'Exclude'
  }
];

export enum InformationType {
  BUTTON = 'BUTTON',
  TEXT = 'TEXT'
}

export enum MockControlState {
  AVAILABLE = 'AVAILABLE',
  EXPIRING_SOON = 'EXPIRING_SOON',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum BannerType {
  WARNING = 'WARNING',
  COUNTDOWN = 'COUNTDOWN',
  BLOCKED = 'BLOCKED',
  NONE = 'NONE'
}
